module.exports = __webpack_public_path__ + "static/blog_grid_3-4d0cc3925587c847d17441e56f427da5.jpg";